<template>
  <div class="modal fade in" @click="open = false" v-if="open">
    <div class="modal-dialog" @click.stop>
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="open = false">
            <i class="fas fa-times"></i>
          </button>
          <h4 class="modal-title">Delete Confirmation</h4>
        </div>
        <div class="modal-body">
          <p>
            Are you sure you want to delete <b>{{ item.product.name }}</b> from
            this order?
          </p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn"
            data-dismiss="modal"
            @click="open = false"
          >
            Cancel
          </button>
          <span class="btn btn-primary" @click="remove()">Yes, I am sure</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from 'src/utilities';
import Stash from 'src/stash';
import ActsAsModal from 'mixins/ActsAsModal';

export default {
  mixins: [ActsAsModal],

  props: [
    {
      name: 'item',
      type: Object,
    },
  ],

  methods: {
    remove() {
      Api.delete(`items/${this.item.id}`).then(() => {
        Stash.removeItem(this.item.order_id, this.item.id);
        this.deleting = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// DeleteItemConfirmation.vue?5de86a26